import type { Dispatch, SetStateAction } from 'react';
import type { FieldValues, UseFormSetValue } from 'react-hook-form';

export type SelectedCountries = {
  phone: string;
  countryAlias?: string | null;
};

type SetCountryAliasProps<T extends FieldValues> = {
  value: string | null;
  countryAlias?: string | null;
  phone: string;
  setSelectedCountry: Dispatch<SetStateAction<SelectedCountries>>;
  setValue?: UseFormSetValue<T | Record<string, string>>;
};
// Note: This function addresses a special case for the United Kingdom (UK) and Republic of Ireland (ROI) due to a limitation in the react-phone-number-input library where using (UK and ROI) as a value is invalid. Consequently, this function explicitly sets the countryAlias to ensure proper functionality.
export const setCountryAlias = <T extends FieldValues>({
  value,
  countryAlias: countryInfoAlias,
  phone,
  setSelectedCountry,
  setValue,
}: SetCountryAliasProps<T>) => {
  switch (value) {
    case 'UK':
      setSelectedCountry({ countryAlias: 'GB', phone });
      setValue?.('countryAlias', 'GB', { shouldDirty: true });
      break;
    case 'ROI':
      setSelectedCountry({ countryAlias: 'IE', phone });
      setValue?.('countryAlias', 'IE', { shouldDirty: true });
      break;
    default:
      setSelectedCountry({ countryAlias: countryInfoAlias, phone });
      setValue?.('countryAlias', countryInfoAlias as string, { shouldDirty: true });
  }
};
